import { useController, useFormContext } from 'react-hook-form';
import OtpInput from 'react-otp-input';
import { OtpInputType } from '@/common/components/base/input/otp/OtpInput.type.ts';
import Input from '@/common/components/base/input/base/Input.tsx';

const Otp = ({ name, numberOfInputs = 5, onChange }: OtpInputType) => {
  const formController = useFormContext();
  const { control } = formController;
  const { field } = useController({
    control,
    name,
  });
  const valueOnChange = (value: string) => {
    field.onChange(value);
    onChange?.(value, value.length === numberOfInputs);
  };
  return (
    <OtpInput
      shouldAutoFocus
      value={field.value}
      onChange={valueOnChange}
      numInputs={numberOfInputs}
      inputType="tel"
      containerStyle={{
        justifyContent: 'space-evenly',
        gap: '15px',
        direction: 'ltr',
      }}
      inputStyle={{
        width: '50px',
        borderRadius: '16px',
      }}
      renderInput={(props) => <Input inputRef={field.ref} inputProps={props} />}
    />
  );
};
export default Otp;
